"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelSubscriptionPageIntroWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var CancelSubscriptionPageIntroWidget = /** @class */ (function (_super) {
    __extends(CancelSubscriptionPageIntroWidget, _super);
    function CancelSubscriptionPageIntroWidget(props) {
        return _super.call(this, props) || this;
    }
    CancelSubscriptionPageIntroWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: this.renderWording() }));
    };
    CancelSubscriptionPageIntroWidget.prototype.renderWording = function () {
        var interaction = this.props.interaction;
        if (interaction.uistate.productsForCancellation.length === 2) {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("h1", { className: "text-group title plugin no-indent", children: "Cancel Car and Renters subscription" }) }));
        }
        else if (interaction.uistate.productsForCancellation.includes(services_1.PRODUCT_MOTOR)) {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("h1", { className: "text-group title plugin no-indent", children: "Cancel Car subscription" }) }));
        }
        else if (interaction.uistate.productsForCancellation.includes(services_1.PRODUCT_RENTERS)) {
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("h1", { className: "text-group title plugin no-indent", children: "Cancel Renters subscription" }) }));
        }
    };
    return CancelSubscriptionPageIntroWidget;
}(plugin_journey_1.WidgetBase));
exports.CancelSubscriptionPageIntroWidget = CancelSubscriptionPageIntroWidget;
//# sourceMappingURL=CancelSubscriptionPageIntroWidget.js.map